export function Logo({ className = "", textClass = "text-stone-900", size = 34 }) {
  return (
    <span className={`flex items-center gap-2 ${className}`}>
      <img src="/logo.png" alt="Gather logo" width={size} height={size} className="object-contain shrink-0" />
      <span className={`font-brand font-extrabold text-xl leading-none ${textClass}`}>Gather</span>
    </span>
  );
}
